export class BaseResponse {
  statusCode: string;
  statusMessage: string;
}
